import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Item from '../Item'
import styles from './style.module.less'
import UploadVideo from './UploadVideo'

@inject('stepTwoStore')
@observer
export default class extends Component {
  render() {
    return (
      <Item label="头图视频">
        <div className={styles.tip}>
          视频比例为 16:9，大小不能超过 500 MB，时长不超过 5 分钟；支持
          rmvb、avi 和 mp4 等格式；<br />点击查看<a
            onClick={this.props.stepTwoStore.howToResizeVideoModal}
          >
            如何修改视频尺寸
          </a>
        </div>
        <div className={styles.imgsWrapper}>
          <div className={styles.covers}>
            <div className={styles.label}>头图视频</div>
            <div className={styles.imgs}>
              <UploadVideo store={this.props.stepTwoStore} />
            </div>
          </div>
        </div>
      </Item>
    )
  }
}
